/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Privacysecurity1Inputs */

const id_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privasi & Keamanan:`)
};

const ms_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privasi & Keselamatan:`)
};

const da_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatliv & Sikkerhed:`)
};

const de_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz & Sicherheit:`)
};

const en_us2_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy & Security:`)
};

const es_es2_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad y seguridad:`)
};

const es_mx2_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad y seguridad:`)
};

const fil_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy at Seguridad:`)
};

const fr_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidentialité et sécurité :`)
};

const it_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy e sicurezza:`)
};

const hu_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatvédelem és biztonság:`)
};

const nl_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy en beveiliging:`)
};

const no_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personvern og sikkerhet:`)
};

const pl_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatność i bezpieczeństwo:`)
};

const pt_br2_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidade e segurança:`)
};

const pt_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidade e segurança:`)
};

const ro_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidențialitate și securitate:`)
};

const fi_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityisyys ja turvallisuus:`)
};

const sv_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritet och säkerhet:`)
};

const vi_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quyền riêng tư & Bảo mật:`)
};

const tr_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik ve Güvenlik:`)
};

const cs_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soukromí a zabezpečení:`)
};

const bg_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поверителност и сигурност:`)
};

const ru_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конфиденциальность и безопасность:`)
};

const uk_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конфіденційність та безпека:`)
};

const ar_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخصوصية والأمان:`)
};

const hi_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोपनीयता और सुरक्षा:`)
};

const th_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความเป็นส่วนตัวและความปลอดภัย:`)
};

const ja_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーとセキュリティ：`)
};

const zh_cn2_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私与安全：`)
};

const zh_hant1_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隱私與安全：`)
};

const ko_notifications_privacysecurity1 = /** @type {(inputs: Notifications_Privacysecurity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보 및 보안:`)
};

/**
* | output |
* | --- |
* | "Privacy & Security:" |
*
* @param {Notifications_Privacysecurity1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_privacysecurity1 = /** @type {((inputs?: Notifications_Privacysecurity1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Privacysecurity1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_privacysecurity1(inputs)
	if (locale === "ms") return ms_notifications_privacysecurity1(inputs)
	if (locale === "da") return da_notifications_privacysecurity1(inputs)
	if (locale === "de") return de_notifications_privacysecurity1(inputs)
	if (locale === "en-US") return en_us2_notifications_privacysecurity1(inputs)
	if (locale === "es-ES") return es_es2_notifications_privacysecurity1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_privacysecurity1(inputs)
	if (locale === "fil") return fil_notifications_privacysecurity1(inputs)
	if (locale === "fr") return fr_notifications_privacysecurity1(inputs)
	if (locale === "it") return it_notifications_privacysecurity1(inputs)
	if (locale === "hu") return hu_notifications_privacysecurity1(inputs)
	if (locale === "nl") return nl_notifications_privacysecurity1(inputs)
	if (locale === "no") return no_notifications_privacysecurity1(inputs)
	if (locale === "pl") return pl_notifications_privacysecurity1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_privacysecurity1(inputs)
	if (locale === "pt") return pt_notifications_privacysecurity1(inputs)
	if (locale === "ro") return ro_notifications_privacysecurity1(inputs)
	if (locale === "fi") return fi_notifications_privacysecurity1(inputs)
	if (locale === "sv") return sv_notifications_privacysecurity1(inputs)
	if (locale === "vi") return vi_notifications_privacysecurity1(inputs)
	if (locale === "tr") return tr_notifications_privacysecurity1(inputs)
	if (locale === "cs") return cs_notifications_privacysecurity1(inputs)
	if (locale === "bg") return bg_notifications_privacysecurity1(inputs)
	if (locale === "ru") return ru_notifications_privacysecurity1(inputs)
	if (locale === "uk") return uk_notifications_privacysecurity1(inputs)
	if (locale === "ar") return ar_notifications_privacysecurity1(inputs)
	if (locale === "hi") return hi_notifications_privacysecurity1(inputs)
	if (locale === "th") return th_notifications_privacysecurity1(inputs)
	if (locale === "ja") return ja_notifications_privacysecurity1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_privacysecurity1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_privacysecurity1(inputs)
	return ko_notifications_privacysecurity1(inputs)
});
export { notifications_privacysecurity1 as "notifications.privacySecurity" }